<template>
  <div class="step-mock-bank-creds step-stagger">
    <h1 class="step-heading" dir="auto">חיבור עם פרטי התחברות (מצב mock)</h1>
    <p class="step-subtitle" dir="auto">
      חיבור ישיר עם שם משתמש וסיסמה ל{{ bank.name }} (מדלג על OAuth)
    </p>

    <div class="inputs-area">
      <FloatingInput
        :label="'שם בעל.ת החשבון'"
        :value="accountName"
        @input="accountName = $event"
      />
      <FloatingInput
        v-for="field in fieldList"
        :key="field.key"
        :label="field.name"
        :value="credentials[field.key]"
        :type="field.type === 'password' ? 'password' : 'text'"
        :input-dir="'ltr'"
        @input="onFieldInput(field.key, $event)"
      />
    </div>

    <div class="cta-area">
      <CtaButton
        :text="loading ? 'מתחבר...' : 'חיבור ל' + bank.name"
        :disabled="!isValid || loading"
        @click="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import FloatingInput from './FloatingInput.vue';
import CtaButton from './CtaButton.vue';

export default {
  name: 'StepMockBankCredentials',
  components: { FloatingInput, CtaButton },
  props: {
    bank: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      accountName: '',
      credentials: {},
    };
  },
  computed: {
    fieldList() {
      const fields = this.bank?.credentials?.fields || {};
      return Object.values(fields);
    },
    isValid() {
      if (!this.accountName.trim()) { return false; }
      return this.fieldList.every(field => (this.credentials[field.key] || '').trim().length > 0);
    },
  },
  methods: {
    onFieldInput(key, value) {
      this.$set(this.credentials, key, value);
    },
    onSubmit() {
      if (!this.isValid) { return; }
      this.$emit('next', {
        accountName: this.accountName.trim(),
        credentials: { ...this.credentials },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.step-mock-bank-creds {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 27px;
}

.step-heading {
  font-family: 'SimplerProAlte', sans-serif;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  color: #205441;
  text-align: center;
  margin: 24px auto 8px;
}

.step-subtitle {
  font-family: 'SimplerPro', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #205441;
  text-align: center;
  margin: 0 auto 24px;
  max-width: 326px;
}

.inputs-area {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cta-area {
  margin-top: auto;
  padding-top: 24px;
  padding-bottom: 8px;
}
</style>
